import React from 'react'

export const LandingPage = () => <h1>Landing Page</h1>
